/* Open the header dropdowns (Goods, Places) on hover as well as on click.

   Dawn drives them from a native <details>, which is click-only, and CSS can't help: a closed
   <details> hides its own content in the UA shadow tree, so there is no selector that reveals
   it. The only lever is the `open` attribute — which is fine, because setting it fires the
   same `toggle` event Dawn's HeaderMenu already listens for. Everything downstream (the
   caret, aria-expanded, the sticky-header preventHide) keeps working with nothing to mirror.

   Hover is a desktop-pointer affordance only. It is gated on `(hover: hover) and
   (pointer: fine)` so a touch device never gets a menu that opens and closes under its
   finger, and on the 990px breakpoint below which the bar is a drawer anyway. Click and
   keyboard are untouched at every size. */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  // long enough to cross the gap between the summary and the panel without it shutting,
  // short enough that it doesn't feel stuck open
  const CLOSE_DELAY = 140;

  function hoverable() {
    return DESKTOP.matches && POINTER.matches;
  }

  function wire(menu) {
    if (menu.dataset.wlHover === 'on') return;
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    menu.dataset.wlHover = 'on';

    let timer;

    // Keep aria-expanded honest however the menu was opened. Dawn only ever writes it on
    // programmatic close, so a native click could leave "false" sitting on an open menu —
    // worse than no attribute, since <summary> already exposes the state natively. `toggle`
    // fires for hover, click and keyboard alike, so syncing here covers all three.
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
    });
    summary.setAttribute('aria-expanded', String(details.open));

    const open = () => {
      clearTimeout(timer);
      if (!hoverable() || details.open) return;
      details.open = true;
    };

    const close = () => {
      clearTimeout(timer);
      if (!hoverable()) return;
      timer = setTimeout(() => {
        // don't yank it shut from under someone tabbing through the links
        if (!details.open || menu.contains(document.activeElement)) return;
        details.open = false;
      }, CLOSE_DELAY);
    };

    menu.addEventListener('pointerenter', open);
    menu.addEventListener('pointerleave', close);

    // With hover open, a click on the label would toggle it straight back shut and then the
    // pointer would immediately reopen it — a flicker. Swallow the pointer click only;
    // `detail === 0` is Enter/Space from the keyboard, which must still toggle.
    summary.addEventListener('click', (event) => {
      if (hoverable() && details.open && event.detail > 0) event.preventDefault();
    });
  }

  function wireAll() {
    document.querySelectorAll('header-menu').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  // the theme editor re-renders the header section in place
  document.addEventListener('shopify:section:load', wireAll);
})();
